import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
const KEY = "asirox_admin_token";

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(KEY) || null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(!!token);

  useEffect(() => {
    if (!token) { setUser(null); setLoading(false); return; }
    api.get("/admin/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(KEY); setToken(null); setUser(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem(KEY, data.token);
    setToken(data.token);
    setUser({ email: data.email, role: "admin" });
    return data;
  };
  const logout = () => { localStorage.removeItem(KEY); setToken(null); setUser(null); };

  const adminFetch = (method, url, body) =>
    api.request({
      method, url, data: body,
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data);

  return <Ctx.Provider value={{ token, user, loading, login, logout, adminFetch }}>{children}</Ctx.Provider>;
}

export function useAdminAuth() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return v;
}
